import * as React from 'react';
import { Grid, Col, Row } from 'react-flexbox-grid';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { compose, withHandlers, withState, defaultProps, withProps } from 'recompose';
import { reduxForm, FormSection } from 'redux-form';
import { get } from 'lodash';
import { InputField, Input, InlineGridField, InlineGrid } from '@components/form';
import { searchDogs, saveDogs } from '@modules/dogs/_dogsActions';
import { Card } from 'material-ui';
import { withNotifications } from '@components/hoc/withNotifications';
import { Loader } from '@components/loader';
import { noop } from 'lodash';
import dogsColumn from '@modules/dogs/_dogsColumns';
import { GeovapActionsBar } from './DogsGridButtons';

const enhance = compose<any, any>(
  defaultProps({
    onSave: noop
  }),
  withState('loading', 'setLoading', false),
  withState('showDogs', 'handleShowDogs', false),
  withState('dogs', 'handleDogs', []),
  withNotifications({ searchDogs, saveDogs }),
  withHandlers({
    onSubmit: ({ handleShowDogs, handleDogs, setLoading, searchDogsNotify }) => async formData => {
      const { dogs, ...body } = formData;
      setLoading(true);
      const response = await searchDogsNotify(body);
      setLoading(false);
      if (response.length) {
        handleShowDogs(true);
        handleDogs(response);
      }
    },
    onSave: ({ onSave, saveDogsNotify, setLoading, closeItem }) => async dogs => {
      setLoading(true);
      const response = await saveDogsNotify(dogs);
      setLoading(false);
      if (response.length) {
        onSave(response);
      }
      closeItem();
    },
    onCloseItem: ({ closeItem, handleShowDogs, handleDogs }) => () => {
      handleShowDogs(false);
      handleDogs([]);
      closeItem();
    }
  }),
  withProps(({ dogs }) => ({ initialValues: { dogs } })),
  reduxForm({
    form: 'dogs-geovap-form',
    enableReinitialize: true
  })
);

export const DogDetail = ({ dog }) => {
  const { idNumber, isFeePaid, name, owner } = dog;
  return (
    <Card style={{ padding: '15px', margin: '15px 0' }}>
      <Row>
        <Col md={12}>
          <h2>Pes</h2>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <span style={{ fontWeight: 'bold' }}>Jméno:&nbsp;</span>
          <span>{name}</span>
        </Col>
        <Col md={4}>
          <span style={{ fontWeight: 'bold' }}>Známka:&nbsp;</span>
          <span>{idNumber}</span>
        </Col>
        <Col md={4}>
          <span style={{ fontWeight: 'bold' }}>Zaplaceno:&nbsp;</span>
          <span>{isFeePaid ? 'Ano' : 'Ne'}</span>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <h2>Majitel</h2>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <span style={{ fontWeight: 'bold' }}>Jméno:&nbsp;</span>
          <span>{get(owner, 'fullName', 'Neznámo')}</span>
        </Col>
        <Col md={6}>
          <span style={{ fontWeight: 'bold' }}>Rodné číslo:&nbsp;</span>
          <span>{get(owner, 'birthDate', 'Neznámo')}</span>
        </Col>
      </Row>
    </Card>
  );
};

const View = ({ onCloseItem, showDogs, loading, handleSubmit, onSave }) => (
  <div style={{ margin: '15px' }}>
    {loading && <Loader />}
    <form onSubmit={handleSubmit}>
      <Grid fluid={true}>
        {!showDogs ? (
          <React.Fragment>
            <Row>
              <Col md={12}>
                <h4>Pes</h4>
              </Col>
            </Row>
            <Row>
              {[
                { label: 'Známka - čip', name: 'tagChip' },
                { label: 'Známka', name: 'tag' },
                { label: 'Čip', name: 'chip' },
                { label: 'Jméno', name: 'name' },
                { label: 'Kód plemena', name: 'breedCode' },
                { label: 'Tetování', name: 'pestetovani' }
              ].map(data => (
                <Col key={data.name} md={4}>
                  <InputField component={Input} id={data.name} {...data} />
                </Col>
              ))}
            </Row>
            <Row>
              <Col md={12}>
                <h4>Poplatník</h4>
              </Col>
            </Row>
            <FormSection name="payer">
              <Row>
                {[
                  { label: 'Příjmení', name: 'lastName' },
                  { label: 'Společnost', name: 'company' },
                  { label: 'Ulice', name: 'street' },
                  { label: 'Číslo popisné', name: 'descriptiveNumber' }
                ].map(data => (
                  <Col key={data.name} md={6}>
                    <InputField component={Input} id={data.name} {...data} />
                  </Col>
                ))}
              </Row>
            </FormSection>
          </React.Fragment>
        ) : (
          <Row className="without-min-width">
            <Col md={12}>
              <InlineGridField
                component={InlineGrid}
                name="dogs"
                columns={dogsColumn}
                showCheckboxes={true}
                adding={false}
                editing={false}
                deleting={false}
                filtering={false}
                sort="name"
                order="ASC"
                version="2"
                gridProps={{
                  pageSize: 1000
                }}
                ActionBar={GeovapActionsBar({ onCloseItem, onSave })}
              />
            </Col>
          </Row>
        )}
      </Grid>

      {!showDogs && (
        <>
          <Button label={'Vyhledat'} type={'submit'} primary={true} style={{ margin: '15px 15px 0 0' }} />
          <Button label={'Zavřít'} onClick={onCloseItem} style={{ marginTop: '15px' }} />
        </>
      )}
    </form>
  </div>
);

export const DogsGeovapModal = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/dogs/DogsGeovapModal.tsx